var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchTeal = function SvgSearchTeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#061e21",
    d: "M16.21 14.636a7.314 7.314 0 0 0-6.18-11.63 7.312 7.312 0 0 0-5.266 12.071 7.31 7.31 0 0 0 9.875 1.132h-.001q.05.067.11.13l4.33 4.331a1.125 1.125 0 1 0 1.593-1.59l-4.331-4.332a1 1 0 0 0-.13-.113zm.29-4.325a6.188 6.188 0 1 1-12.376 0 6.188 6.188 0 0 1 12.377 0"
  })));
};
export default SvgSearchTeal;